module.exports = __webpack_public_path__ + "img/walter_raab__kraefte_aktivieren.568f7a5d.jpg";